// Domini della piattaforma NoleggioinCloud — qualsiasi altro hostname è un
// dominio personalizzato di un cliente (noleggio) collegato alla piattaforma.
// Usato sia da App.js (per decidere se fare il routing "dominio personalizzato")
// sia da config/firebase.js (per decidere se inizializzare App Check/reCAPTCHA:
// va attivato SOLO sui domini piattaforma, perché le uniche Cloud Function
// protette — registerCompany e checkSlugAvailability — vengono chiamate solo
// dalla pagina di registrazione e dal pannello admin, mai da un sito cliente
// su dominio personalizzato).
export const PLATFORM_HOSTNAMES = new Set([
  'noleggioincloud.app',
  'www.noleggioincloud.app',
  'noleggioincloud.web.app',
  'noleggioincloud.firebaseapp.com',
  'localhost',
  '127.0.0.1',
]);

// NB: dal momento che noleggioincloud.app fa redirect a www.noleggioincloud.app
// (Firebase Hosting), il broker deve stare direttamente su www: con l'apex il
// popup verrebbe rimandato a un'altra origin e i postMessage (verificati con
// event.origin in CustomerAuthScreen) verrebbero scartati.
// Origine della pagina "broker" per il login Google sui domini personalizzati
// dei clienti — vedi src/pages/AuthBrokerScreen.js e
// functions/index.js (exchangeAuthForCustomToken) per la spiegazione
// completa del perché serve. Deve essere un dominio SEMPRE presente in
// "Authorized domains" su Firebase Auth (lo è già: è un dominio di
// piattaforma). In sviluppo locale il broker gira su localhost stesso,
// quindi lì non serve nessuna finestra popup verso un altro dominio.
export const AUTH_BROKER_ORIGIN =
  typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? window.location.origin
    : 'https://www.noleggioincloud.app';
